
const breadcrumbScrollDiv: HTMLElement = document.querySelector(".breadcrumb-scroll-wrapper");
const linearGradient: HTMLElement = document.querySelector(".breadcrumb-left-linear-gradient");

const init = () => {
  toggleLinearGradient();

  window.addEventListener('resize', (e) => {
    toggleLinearGradient();
  });

  /* 
    Show/hide breadcrumb left gradient based on 
    if a user scrolls to the start of the breaccrumbs.
  */
  breadcrumbScrollDiv.addEventListener("scroll", (e) => {
    if (breadcrumbScrollDiv.offsetWidth + Math.abs(breadcrumbScrollDiv.scrollLeft) >= breadcrumbScrollDiv.scrollWidth - 10) {
      linearGradient.style.display = "none";
    } else {
      linearGradient.style.display = "block";
    }
  });
}

/* 
  Show/hide breadcrumb left gradient based on 
  screen size and if breadcrumbs are outside view.
*/
const toggleLinearGradient = () => {
  if (isOverflown({
    clientWidth: window.innerWidth,
    clientHeight: window.innerHeight,
    scrollWidth: breadcrumbScrollDiv.scrollWidth,
    scrollHeight: breadcrumbScrollDiv.scrollHeight
  })) {
    linearGradient.style.display = "block";
  }
  else {
    linearGradient.style.display = "none";
  }
}

const isOverflown = ({
  clientWidth,
  clientHeight,
  scrollWidth,
  scrollHeight
}: {
    clientWidth: number,
    clientHeight: number,
    scrollWidth: number,
    scrollHeight: number
}) => {
  return scrollHeight > clientHeight || scrollWidth > clientWidth;
}

export const BreadCrumbs = {
  init
}